import { useEffect } from 'react';

const loadedScripts = {};

function useScript(url) {
    if (loadedScripts[url]) {
        return;
    }

    useEffect(() => {
        const script = document.createElement('script');

        script.src = url;
        script.async = true;
        script.crossOrigin = '';

        document.body.appendChild(script);

        loadedScripts[url] = true;

        return () => {
            if (script.src.includes(url)) {
                document.body.removeChild(script);
                loadedScripts[url] = false;
            }
        };
    }, [url]);
}

export { useScript };
